<template>
  <v-app>
    <core-app-bar />
    <core-drawer />
    <core-view />
    <core-footer />

    <v-snackbar :value="showSnack" :timeout="3000" :color="snackColor">
      {{ snackText }}
    </v-snackbar>
  </v-app>
</template>

<script>

  export default {
    components: {
      CoreDrawer: () => import('@/components/core/Drawer'),
      CoreFooter: () => import('@/components/core/Footer'),
      CoreAppBar: () => import('@/components/core/AppBar'),
      CoreView: () => import('@/components/core/View')
    },
    computed : {
      showSnack() { return this.$store.state.showSnack; },
      snackColor() { return this.$store.state.snackColor; },
      snackText() { return this.$store.state.snackText; },
    },
    beforeCreate : function() {
      this.$store.dispatch("tryAuthenticateUser");
    }
  }

</script>
